module.exports = __webpack_public_path__ + "img/app-logo@2x.60e69275.png";